import { createKeyedAsyncReducer } from '../../../redux-util/async-helpers';
import {
  LIST_ADOPTION_USERS,
  UPDATE_ADOPTION_USERS,
} from '../../bridge-method-remap';
import { getAsyncReducerWithModify } from '../../bridge-async-modifier';
import { getBatchUpdateReducer } from '../helpers';

export default createKeyedAsyncReducer({
  actionKeys: [LIST_ADOPTION_USERS],
  param: 'adoption',
  itemReducer: getAsyncReducerWithModify({
    fetchKey: LIST_ADOPTION_USERS,
    appendNode: 'users',
    itemParam: 'id',
  }),
  globalReducer: getBatchUpdateReducer({
    updateAction: UPDATE_ADOPTION_USERS,
    paramNodeName: 'users',
    itemKeyName: 'id',
    outputNodeName: 'users',
    useStart: true,
  }),
});
